<template>
  <div class="callback">
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
  created() {
    if (this.$route.query.token) {
      sessionStorage.setItem('token', this.$route.query.token);
      this.$router.replace({ path: '/' + this.$route.query.redirectUrl });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
